import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useSelector } from 'react-redux';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { designSystemEditingBlocked } from 'redux/db/util';
import { startDsChatDraft } from 'redux/mode/util';
import { displayDsReadOnlyModal } from 'redux/mode/util/modals';
import { RootReducer } from 'redux/reducers';

const NewChatAction = () => {
	const designSystem = useSelector((r: RootReducer) =>
		selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId)
	);

	const onClick = () => {
		if (!designSystem) return;

		const blocked = designSystemEditingBlocked();
		if (blocked && blocked !== 'historical') {
			displayDsReadOnlyModal(blocked);
			return;
		}

		// The new chat is a client-only draft; it hits the server only once its first
		// message is sent.
		startDsChatDraft();
	};

	return <ActionButton icon={IconType.CHAT_NEW} label="Start a fresh chat" onClick={onClick} />;
};

export default NewChatAction;
